import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  saldo: 0
}

// mutations
export const mutations = {

  [types.SAVE_SALDO] (state, { saldo }) {
    var x = parseFloat(saldo)
    var saldoResultante = (x <= 0) ? Math.abs(x) : (x * -1)
    state.saldo = parseFloat(saldoResultante)
  }

}

// actions
export const actions = {

  async fetchSaldo ({ commit }) {
    try {
      const { data } = await axios.get('/api/cliente/saldo-existente')
      let saldo = 0
      if (data.length !== 0) {
        saldo = data[0].diferencia
      }
      commit(types.SAVE_SALDO, { saldo: saldo })
    } catch (e) {
      console.log(e.response)
    }
  }

}

// getters
export const getters = {
  getSaldoAgremiado: state => state.saldo
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/saldo.js